import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const hpField = formData.get('phone_alt') as string;
    if (hpField && hpField.trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    formData.delete('phone_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9qmnl6e3oq4jqumtn3g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setStatus('error');
          setMessage('订阅失败，请稍后再试。');
        } else {
          setStatus('error');
          setMessage(serverMsg || '订阅失败，请稍后再试。');
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络后重试。');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-950">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto rounded-2xl bg-primary-500/20 text-primary-400 mb-6">
          <i className="ri-mail-send-line text-2xl"></i>
        </div>
        <h2
          className="text-2xl md:text-3xl font-bold text-background-50 mb-3"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          订阅最新资讯
        </h2>
        <p className="text-background-400 text-sm mb-8 leading-relaxed">
          第一时间获取凤楼区域的最新资讯和独家内容，不错过任何重要信息。
        </p>

        <form onSubmit={handleSubmit} data-readdy-form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <div className="hp-field-wrapper">
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="请输入您的邮箱地址"
            className="flex-1 px-4 py-3 bg-background-800 border border-background-700 rounded-lg text-sm text-background-100 placeholder:text-background-500 focus:outline-none focus:border-primary-500 transition-colors"
          />
          <button
            type="submit"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            立即订阅
          </button>
        </form>

        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-green-400' : 'text-red-400'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}